import React, { useState } from 'react';
import { bannerApi } from '../../config/api.config';

const BannerModal = ({ isOpen, onClose, onSuccess }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [previewUrl, setPreviewUrl] = useState('');
    const [title, setTitle] = useState('');
    const [linkUrl, setLinkUrl] = useState('');
    const [placement, setPlacement] = useState('home_top');
    const [isActive, setIsActive] = useState(true);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            
            // 미리보기 URL 생성
            const reader = new FileReader();
            reader.onload = (e) => {
                setPreviewUrl(e.target.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!selectedFile) {
            alert('파일을 선택해주세요.');
            return;
        }

        if (!title.trim()) {
            alert('배너 제목을 입력해주세요.');
            return;
        }

        setLoading(true);
        
        let bannerId = null; // bannerId를 try 블록 밖에서 선언

        try {
            // 1단계: 배너 메타데이터를 JSON으로 먼저 전송
            const bannerData = {
                title: title.trim(),
                linkUrl: linkUrl.trim(),
                placement: placement,
                isActive: isActive
            };
            
            console.log('1단계: 배너 메타데이터 전송:', bannerData);
            
            // JSON 데이터만 먼저 전송
            const metadataResponse = await bannerApi.post('/admin/metadata', bannerData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            
            console.log('메타데이터 응답:', metadataResponse.data);
            bannerId = metadataResponse.data.id;
            
            // 2단계: 파일만 별도로 전송
            console.log('2단계: 파일 전송 시작');
            const formData = new FormData();
            formData.append('file', selectedFile);
            
            const fileResponse = await bannerApi.post(`/admin/file/${bannerId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            
            console.log('파일 업로드 응답:', fileResponse.data);
            
            alert('배너가 성공적으로 업로드되었습니다.');
            setSelectedFile(null);
            setPreviewUrl('');
            setTitle('');
            setLinkUrl('');
            setPlacement('home_top');
            setIsActive(true);
            onSuccess();
            onClose();
        } catch (error) {
            console.error('배너 업로드 실패:', error);
            
            // 파일 업로드 실패 시 메타데이터 삭제 시도 (bannerId가 있는 경우에만)
            if (bannerId) {
                try {
                    console.log('메타데이터 삭제 시도:', bannerId);
                    await bannerApi.delete(`/admin/${bannerId}`);
                    console.log('메타데이터 삭제 완료');
                } catch (deleteError) {
                    console.error('메타데이터 삭제 실패:', deleteError);
                }
            } else {
                console.log('bannerId가 없어서 메타데이터 삭제를 건너뜀');
            }
            
            // 에러 메시지 표시
            let errorMessage = '배너 업로드에 실패했습니다.';
            if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error.message) {
                errorMessage = error.message;
            }
            
            alert(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setSelectedFile(null);
        setPreviewUrl('');
        setTitle('');
        setLinkUrl('');
        setPlacement('home_top');
        setIsActive(true);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        }}>
            <div style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                padding: '24px',
                width: '500px',
                maxWidth: '90vw',
                maxHeight: '90vh',
                overflow: 'auto'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px'
                }}>
                    <h2 style={{
                        margin: 0,
                        fontSize: '20px',
                        fontWeight: 'bold',
                        color: '#333'
                    }}>
                        배너 추가
                    </h2>
                    <button
                        onClick={handleClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '24px',
                            cursor: 'pointer',
                            color: '#666',
                            padding: '0',
                            width: '30px',
                            height: '30px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        ×
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            fontWeight: '500',
                            color: '#333'
                        }}>
                            배너 제목 *
                        </label>
                        <input
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="배너 제목을 입력하세요"
                            required
                            style={{
                                width: '100%',
                                padding: '12px',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                fontSize: '14px',
                                boxSizing: 'border-box'
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            fontWeight: '500',
                            color: '#333'
                        }}>
                            배너 이미지 *
                        </label>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            required
                            style={{
                                width: '100%',
                                padding: '12px',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                fontSize: '14px',
                                boxSizing: 'border-box'
                            }}
                        />
                        <div style={{
                            fontSize: '12px',
                            color: '#666',
                            marginTop: '4px'
                        }}>
                            지원 형식: JPG, PNG, GIF (최대 5MB)
                        </div>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            fontWeight: '500',
                            color: '#333'
                        }}>
                            링크 URL (선택사항)
                        </label>
                        <input
                            type="url"
                            value={linkUrl}
                            onChange={(e) => setLinkUrl(e.target.value)}
                            placeholder="https://example.com 또는 app://page"
                            style={{
                                width: '100%',
                                padding: '12px',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                fontSize: '14px',
                                boxSizing: 'border-box'
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '12px',
                            fontWeight: '500',
                            color: '#333'
                        }}>
                            📍 배너 위치
                        </label>
                        <div style={{
                            display: 'flex',
                            gap: '12px',
                            flexWrap: 'wrap'
                        }}>
                            {[
                                { value: 'home_top', label: '홈 상단', color: '#4caf50', icon: '🏠' },
                            ].map((option) => (
                                <button
                                    key={option.value}
                                    type="button"
                                    onClick={() => setPlacement(option.value)}
                                    style={{
                                        flex: '1',
                                        minWidth: '140px',
                                        padding: '16px 20px',
                                        border: placement === option.value ? `3px solid ${option.color}` : '2px solid #e0e0e0',
                                        borderRadius: '12px',
                                        background: placement === option.value ? `${option.color}15` : '#fff',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                        fontWeight: '600',
                                        color: placement === option.value ? option.color : '#666',
                                        transition: 'all 0.2s',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        boxShadow: placement === option.value ? `0 2px 8px ${option.color}30` : '0 1px 3px rgba(0,0,0,0.1)'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (placement !== option.value) {
                                            e.currentTarget.style.borderColor = option.color;
                                            e.currentTarget.style.background = `${option.color}10`;
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                            e.currentTarget.style.boxShadow = `0 4px 12px ${option.color}20`;
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (placement !== option.value) {
                                            e.currentTarget.style.borderColor = '#e0e0e0';
                                            e.currentTarget.style.background = '#fff';
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                                        }
                                    }}
                                >
                                    <span style={{ fontSize: '20px' }}>{option.icon}</span>
                                    <span>{option.label}</span>
                                </button>
                            ))}
                        </div>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontWeight: '500',
                            color: '#333'
                        }}>
                            <input
                                type="checkbox"
                                checked={isActive}
                                onChange={(e) => setIsActive(e.target.checked)}
                                style={{
                                    width: '16px',
                                    height: '16px'
                                }}
                            />
                            활성화 상태로 생성
                        </label>
                    </div>

                    {previewUrl && (
                        <div style={{ marginBottom: '20px' }}>
                            <label style={{
                                display: 'block',
                                marginBottom: '8px',
                                fontWeight: '500',
                                color: '#333'
                            }}>
                                미리보기
                            </label>
                            <div style={{
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                overflow: 'hidden',
                                maxHeight: '200px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                                <img
                                    src={previewUrl}
                                    alt="미리보기"
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '200px',
                                        objectFit: 'contain'
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    <div style={{
                        display: 'flex',
                        gap: '12px',
                        justifyContent: 'flex-end'
                    }}>
                        <button
                            type="button"
                            onClick={handleClose}
                            style={{
                                padding: '12px 24px',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                backgroundColor: 'white',
                                color: '#666',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '500'
                            }}
                        >
                            취소
                        </button>
                        <button
                            type="submit"
                            disabled={loading || !selectedFile}
                            style={{
                                padding: '12px 24px',
                                border: '1px solid #1976d2',
                                borderRadius: '4px',
                                backgroundColor: loading || !selectedFile ? '#ccc' : '#1976d2',
                                color: 'white',
                                cursor: loading || !selectedFile ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                fontWeight: '500',
                                opacity: loading || !selectedFile ? 0.6 : 1
                            }}
                        >
                            {loading ? '업로드 중...' : '업로드'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default BannerModal; 